import { Form, message } from 'antd'
import _ from 'lodash'
import { useEffect, useReducer } from 'react'
import { useLocation } from 'react-router-dom'
import {
  BATCH_GET_ORDER_PRODUCT_INFO,
  GET_BATCH_ORDER_DETAIL,
  GET_INVOICE_INFO_BY_ID,
  InvoiceInfoParam,
  OrderInvoiceParams,
  POST_BATCH_SUBMIT_ORDER_INVOICE,
  SUBMIT_ORDER_INVOICE,
} from '../../api/orderManage'
import { fileFile } from '../../modules/uploadfiles/hooks'
import {
  GetLocalStorage,
  formatStr,
  invoicingType,
  isResponseCodeSuccess,
} from '../../tools/util'
import {
  useCloseTab,
  usePageCache,
  useSkipInitEffect,
} from '../../tools/utilHooks'
import reducer, {
  RouteParams,
  initialState,
  reloadStateAction,
  setFormDataAction,
  setIsPageLoadingAction,
  setIsSubmitButtonLoadingAction,
  setMaterialDataAction,
  setOrderDataAction,
  setRouteParamsAction,
  setUploadFilesListAction,
} from './reducer'

export function useSetupHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const [form] = Form.useForm()
  const { uploadFilesList, routeParams } = state
  const { pathname, state: routeState } = useLocation<RouteParams>()
  const { onCurrentPageClose } = useCloseTab()
  const { setCacheWithKey, getCacheWithKey } = usePageCache()
  const CACHE_KEY = pathname

  const handleUploadfilesChange = (e: fileFile[]) => {
    dispatch(setUploadFilesListAction(e))
    form.setFieldsValue({
      file: e,
    })
  }

  const getDetailInfo = async (orderIds: string[]) => {
    dispatch(setIsPageLoadingAction(true))
    const res = await GET_BATCH_ORDER_DETAIL({
      orderId: orderIds.join(),
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      dispatch(setOrderDataAction(resData))
    } else {
      message.warning(res.msg)
    }
    // 获取商品明细数据
    const resList = await BATCH_GET_ORDER_PRODUCT_INFO({
      orderIds: orderIds.join(','),
    })
    if (isResponseCodeSuccess(resList.code)) {
      const list = resList.data
        .map((item) => {
          return item.productDetailVO.map((i) => {
            return {
              ...i,
              orderNo: item.orderNo,
            }
          })
        })
        .flat()
      dispatch(setMaterialDataAction(list))
    } else {
      message.warning(res.msg)
    }
    dispatch(setIsPageLoadingAction(false))
  }

  const handleClosePage = () => {
    onCurrentPageClose()
  }

  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    dispatch(setIsSubmitButtonLoadingAction(true))
    const params = {
      ...(_.omit(formValues, ['file']) as any),
    }
    const res =
      routeParams.orderIds.length === 1
        ? await SUBMIT_ORDER_INVOICE({
            ...params,
            orderId: routeParams.orderIds[0],
            fileIdList: uploadFilesList.map((item) => item.id),
          })
        : await POST_BATCH_SUBMIT_ORDER_INVOICE({
            ...params,
            orderIds: routeParams.orderIds,
            orderInvoiceFileDTOS: uploadFilesList.map((item) => ({
              url: item.url,
              uploadMan: GetLocalStorage('USER_NAME'),
            })),
          })
    if (isResponseCodeSuccess(res.code)) {
      message.success('开票申请成功')
      onCurrentPageClose()
    }
    dispatch(setIsSubmitButtonLoadingAction(false))
  }

  const handleFormValueChange = (changedValues: any, allValues: any) => {
    dispatch(setFormDataAction(allValues))
  }

  const getInvoiceInfo = async (params: InvoiceInfoParam) => {
    const res = await GET_INVOICE_INFO_BY_ID(params)
    if (isResponseCodeSuccess(res.code)) {
      const newFormData = {
        address: res.data.invoiceAddress,
        // 去除银行账户中间的空格
        bankAccount: formatStr(res.data.bankAccount, 'bankAccount'), // 银行账号
        bankName: res.data.bankName,
        content: res.data.invoiceFaceInfo,
        mobile: res.data.openInvoiceMobile,
        orderInvoiceEnums:
          invoicingType.find((item) => {
            return res.data.invoiceTypeStr === item.name
          })?.value ?? undefined,
        receiveAddress: res.data.invoiceAddress,
        receiveMan: res.data.receiveMan,
        receiveMobile: res.data.mobile,
        taxNumber: res.data.taxCode,
        title: res.data.invoiceTitle,
      } as OrderInvoiceParams
      form.setFieldsValue(newFormData)
      dispatch(setFormDataAction(newFormData))
    }
  }

  const loadPageState = (data: any) => {
    dispatch(reloadStateAction(data))
    form.setFieldsValue(data.formData)
  }

  useEffect(() => {
    const flag = getCacheWithKey(CACHE_KEY)
    if (flag && !routeState) {
      // 切换页签时
      dispatch(reloadStateAction(flag))
      loadPageState(flag)
      getDetailInfo(flag.routeParams.orderIds)
    } else if (routeState) {
      if (routeState?.orderIds.length === 1) {
        getInvoiceInfo({
          orderId: routeState?.orderIds?.[0],
        })
      }
      dispatch(setRouteParamsAction(routeState))
      getDetailInfo(routeState.orderIds)
    }
    // eslint-disable-next-line
  }, [])

  useSkipInitEffect(() => {
    // 缓存存数据
    setCacheWithKey(state, CACHE_KEY)
    // eslint-disable-next-line
  }, [state])

  return {
    state,
    form,
    handleUploadfilesChange,
    handleClosePage,
    handleSubmit,
    handleFormValueChange,
  }
}
import { Form, message } from 'antd'
import _ from 'lodash'
import { useEffect, useReducer } from 'react'
import { useLocation } from 'react-router-dom'
import {
  BATCH_GET_ORDER_PRODUCT_INFO,
  GET_BATCH_ORDER_DETAIL,
  GET_INVOICE_INFO_BY_ID,
  InvoiceInfoParam,
  OrderInvoiceParams,
  POST_BATCH_SUBMIT_ORDER_INVOICE,
  SUBMIT_ORDER_INVOICE,
} from '../../api/orderManage'
import { fileFile } from '../../modules/uploadfiles/hooks'
import {
  GetLocalStorage,
  formatStr,
  invoicingType,
  isResponseCodeSuccess,
} from '../../tools/util'
import {
  useCloseTab,
  usePageCache,
  useSkipInitEffect,
} from '../../tools/utilHooks'
import reducer, {
  RouteParams,
  initialState,
  reloadStateAction,
  setFormDataAction,
  setIsPageLoadingAction,
  setIsSubmitButtonLoadingAction,
  setMaterialDataAction,
  setOrderDataAction,
  setRouteParamsAction,
  setUploadFilesListAction,
} from './reducer'

export function useSetupHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const [form] = Form.useForm()
  const { uploadFilesList, routeParams } = state
  const { pathname, state: routeState } = useLocation<RouteParams>()
  const { onCurrentPageClose } = useCloseTab()
  const { setCacheWithKey, getCacheWithKey } = usePageCache()
  const CACHE_KEY = pathname

  const handleUploadfilesChange = (e: fileFile[]) => {
    dispatch(setUploadFilesListAction(e))
    form.setFieldsValue({
      file: e,
    })
  }

  const getDetailInfo = async (orderIds: string[]) => {
    dispatch(setIsPageLoadingAction(true))
    const res = await GET_BATCH_ORDER_DETAIL({
      orderId: orderIds.join(),
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      dispatch(setOrderDataAction(resData))
    } else {
      message.warning(res.msg)
    }
    // 获取商品明细数据
    const resList = await BATCH_GET_ORDER_PRODUCT_INFO({
      orderIds: orderIds.join(','),
    })
    if (isResponseCodeSuccess(resList.code)) {
      const list = resList.data
        .map((item) => {
          return item.productDetailVO.map((i) => {
            return {
              ...i,
              orderNo: item.orderNo,
            }
          })
        })
        .flat()
      dispatch(setMaterialDataAction(list))
    } else {
      message.warning(res.msg)
    }
    dispatch(setIsPageLoadingAction(false))
  }

  const handleClosePage = () => {
    onCurrentPageClose()
  }

  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    dispatch(setIsSubmitButtonLoadingAction(true))
    const params = {
      ...(_.omit(formValues, ['file']) as any),
    }
    const res =
      routeParams.orderIds.length === 1
        ? await SUBMIT_ORDER_INVOICE({
            ...params,
            orderId: routeParams.orderIds[0],
            fileIdList: uploadFilesList.map((item) => item.id),
          })
        : await POST_BATCH_SUBMIT_ORDER_INVOICE({
            ...params,
            orderIds: routeParams.orderIds,
            orderInvoiceFileDTOS: uploadFilesList.map((item) => ({
              url: item.url,
              uploadMan: GetLocalStorage('USER_NAME'),
            })),
          })
    if (isResponseCodeSuccess(res.code)) {
      message.success('开票申请成功')
      onCurrentPageClose()
    }
    dispatch(setIsSubmitButtonLoadingAction(false))
  }

  const handleFormValueChange = (changedValues: any, allValues: any) => {
    dispatch(setFormDataAction(allValues))
  }

  const getInvoiceInfo = async (params: InvoiceInfoParam) => {
    const res = await GET_INVOICE_INFO_BY_ID(params)
    if (isResponseCodeSuccess(res.code)) {
      const newFormData = {
        address: res.data.invoiceAddress,
        // 去除银行账户中间的空格
        bankAccount: formatStr(res.data.bankAccount, 'bankAccount'), // 银行账号
        bankName: res.data.bankName,
        content: res.data.invoiceFaceInfo,
        mobile: res.data.openInvoiceMobile,
        orderInvoiceEnums:
          invoicingType.find((item) => {
            return res.data.invoiceTypeStr === item.name
          })?.value ?? undefined,
        receiveAddress: res.data.invoiceAddress,
        receiveMan: res.data.receiveMan,
        receiveMobile: res.data.mobile,
        taxNumber: res.data.taxCode,
        title: res.data.invoiceTitle,
      } as OrderInvoiceParams
      form.setFieldsValue(newFormData)
      dispatch(setFormDataAction(newFormData))
    }
  }

  const loadPageState = (data: any) => {
    dispatch(reloadStateAction(data))
    form.setFieldsValue(data.formData)
  }

  useEffect(() => {
    const flag = getCacheWithKey(CACHE_KEY)
    if (flag && !routeState) {
      // 切换页签时
      dispatch(reloadStateAction(flag))
      loadPageState(flag)
      getDetailInfo(flag.routeParams.orderIds)
    } else if (routeState) {
      if (routeState?.orderIds.length === 1) {
        getInvoiceInfo({
          orderId: routeState?.orderIds?.[0],
        })
      }
      dispatch(setRouteParamsAction(routeState))
      getDetailInfo(routeState.orderIds)
    }
    // eslint-disable-next-line
  }, [])

  useSkipInitEffect(() => {
    // 缓存存数据
    setCacheWithKey(state, CACHE_KEY)
    // eslint-disable-next-line
  }, [state])

  return {
    state,
    form,
    handleUploadfilesChange,
    handleClosePage,
    handleSubmit,
    handleFormValueChange,
  }
}
